/* REMEDY cart progress bar - display corrections.
   DISPLAY ONLY. Never adds, removes or prices anything. The gift
   engine in endrock.scripts.js is untouched and still decides the
   gift entirely on its own.

   What this fixes:

   1) SEGMENT FILL. The Liquid fills every segment as
      cart / tierAmount, so segment 2 measures from zero instead of
      from tier 1. At $60 on a $50->$75 span it showed 80% full when
      the customer was 40% of the way. Each segment now fills across
      its own span.

   2) THE TIER-1 DEAD BAND. The Liquid compares everything to
      cart.total_price (AFTER discounts), but the 15% discount is
      gated on the pre-discount subtotal. So a $58 cart pays $49.30
      and the bar says "$0.70 away from 15% Off" while the discount
      is already applied to every line. Band is $50.00-$58.82.

      Tiers that hand out a gift stay on total_price so this never
      disagrees with the gift engine. Display-only tiers (no gift)
      switch to original_total_price, which is what actually gates
      them. window.gamificationTiers lists exactly the gift tiers.

   3) THE RE-RENDER RACE. liquid-ajax-cart replaces the whole cart
      section with fresh server HTML on every update, which wiped
      the corrections a moment after they were applied. A
      MutationObserver now re-applies whenever un-corrected markup
      appears. Corrected nodes are stamped data-rmp-done, so this
      cannot loop.

   ROUNDING: whole units, rounded UP, to match the same rounding in
   cart-gamification.liquid. "$0.70 away" reads "$1 away". Never
   round down or a customer is told they are $0 away while short.

   EDIT THE COPY HERE. [$] is replaced with the remaining amount,
   same convention as the theme editor fields: */
var REMEDY_UNLOCKED_TEMPLATE = "You've unlocked <strong>15% Off</strong>. You're [$] away from your free gift.";

(function () {
  var lastCart = null;

  function money(cents) {
    return '$' + Math.ceil(cents / 100);
  }

  function giftAmounts() {
    var t = window.gamificationTiers;
    return (t && t.length) ? t.map(function (x) { return x.amount; }) : [];
  }

  function apply(cart) {
    if (!cart || typeof cart.total_price !== 'number') { return; }

    var post = cart.total_price;
    var pre = typeof cart.original_total_price === 'number' ? cart.original_total_price : post;
    var gifts = giftAmounts();
    var firstUnmet = null;
    var rescued = false;

    document.querySelectorAll('.pw-gamification__bars-container').forEach(function (group) {
      var prev = 0;
      group.querySelectorAll('.pw-gamification__tier-container[data-tier-amount]').forEach(function (c) {
        var amt = parseInt(c.getAttribute('data-tier-amount'), 10);
        if (isNaN(amt)) { return; }

        var isGiftTier = gifts.indexOf(amt) !== -1;
        var total = isGiftTier ? post : pre;

        var fill = c.querySelector('.pw-gamification__bar-fill');
        if (fill) {
          var span = amt - prev;
          var pct;
          if (total >= amt) { pct = 100; }
          else if (total <= prev || span <= 0) { pct = 0; }
          else { pct = ((total - prev) / span) * 100; }
          fill.style.width = pct.toFixed(2) + '%';
        }

        var node = c.querySelector('.cart-tier');
        if (node) {
          if (total >= amt) {
            node.classList.add('pw-gamification__tier--active');
            if (!isGiftTier && post < amt) { rescued = true; }
          } else {
            node.classList.remove('pw-gamification__tier--active');
            if (firstUnmet === null) { firstUnmet = amt; }
          }
        }

        c.setAttribute('data-rmp-done', '1');
        prev = amt;
      });
    });

    // Rewrite the headline ONLY in the case the server gets wrong:
    // a display-only tier is genuinely met but total_price says not.
    document.querySelectorAll('.pw-gamification__message').forEach(function (p) {
      if (rescued) {
        var remaining = firstUnmet === null ? 0 : Math.max(firstUnmet - post, 0);
        p.innerHTML = REMEDY_UNLOCKED_TEMPLATE.replace('[$]', money(remaining));
      }
      p.setAttribute('data-rmp-done', '1');
    });
  }

  function applyNow() {
    if (lastCart) { apply(lastCart); return; }
    refresh();
  }

  function refresh() {
    var c = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (c && typeof c.total_price === 'number') {
      lastCart = c;
      apply(c);
      return;
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastCart = cart; apply(cart); })
      .catch(function () {});
  }

  document.addEventListener('liquid-ajax-cart:request-end', function (e) {
    lastCart = (e && e.detail && e.detail.cart) ? e.detail.cart : null;
    setTimeout(applyNow, 0);
  });
  document.addEventListener('liquid-ajax-cart:sections-loaded', function () {
    setTimeout(applyNow, 0);
  });

  // Re-apply whenever the section is swapped back in from the server.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      if (document.querySelector('.pw-gamification__message:not([data-rmp-done])') ||
          document.querySelector('.pw-gamification__tier-container[data-tier-amount]:not([data-rmp-done])')) {
        applyNow();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
